import type { FaireProductEntity } from "../../entity_types/product";

export const p_5qdsy7a997: FaireProductEntity = {
  token: "p_5qdsy7a997",
  type: "product",
  name: "Wind River Meditation Chime - Small- Wholesale",
  brandToken: "b_8z7zv9rr",
  brandName: "Wind River",
  imageUrl:
    "https://cdn.faire.com/fastly/f2ce329f1af0e82e7289b23d38a2842dea1247b544e7ff0d6c1e42acecdbe682.jpeg",
  galleryImageUrls: [],
  priceDollars: 51.74,
  description:
    'Find a moment to breathe, relax and reset with a Wind River meditation chime. The soothing tones of Wind River chimes are now available indoors - no matter where you live or what today’s weather brings. Strike a note to pause, regroup and appreciate life, one moment and at a time.\n\nWind River meditation chimes are available in two introductory sizes, tuned to match the longest and shortest of our popular Corinthian Bells 50" Wind Chime.\n\n\nTube length is 19.25"\n\n\n\n\n\n',
  tags: [],
  msrpDollars: 108.65,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:55:11.147Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
